export default "__VITE_ASSET__b2985a3b__"